import React from "react"
import cx from "classnames"
import styles from "./SingleLeaderHeaderSummery.module.css"
import Image from "next/image";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Link from "next/link";
import twitterIcon from "../../../images/twitterIcon.svg";
import linkedinIcon from "../../../images/linkedinIcon.svg";
import parse from 'html-react-parser';

const SingleLeaderHeaderSummery = ({leader, direction = "rtl"}) => {
    return (
        <>
            <div
                style={{direction: direction}}
                className={cx(styles.container, "w-100", "d-flex", "flex-column-reverse", "flex-lg-row", "align-items-end", "justify-content-between")}>
                <div
                    className={cx(styles.leaderInfoStyles, "d-flex", "flex-column", "align-items-lg-start", "justify-content-lg-center")}>
                    <h1 className={cx(styles.mainTitleStyles, "m-0")}>{(direction === "rtl" ? (leader.first_name_fa) : (leader.first_name_en)) + " " + (direction === "rtl" ? (leader.last_name_fa) : (leader.last_name_en))}</h1>
                    <div className="my-3">
                        {leader.memberships.map((a, i) => (
                            <p
                                key={i}
                                className={cx(styles.roleTextStyles)}
                            >
                                {direction === "rtl" ? (
                                    <>
                                        {a.leader_title_fa} {String(a.group.title_fa).replace('هیئت مدیره ' , '').replace("راهبران" , "").replace('مدیران عامل زیر مجموعه‌های گروه تجارت الکترونیک دیجی‌کالا', '')}
                                    </>
                                ) : (`${a.leader_title_en} ${String(a.group.title_en).replace('Board' , '').replace('Digikala Leadership', 'of Digikala').replace('Digikala Group Leadership', 'of Digikala Group').replace('CEOs of Digikala Group Subsidiaries' , '')}`)}
                            </p>
                        ))}
                    </div>

                    <div
                        className={cx(styles.socialsWrapperStyles, "d-flex", "align-items-center", "justify-content-lg-center", "justify-content-start")}>
                        {/*{leader.socials.map((item, index) => (*/}
                        {/*    <LinkedInIcon*/}
                        {/*        style={{*/}
                        {/*            color: "#9E9E9E",*/}
                        {/*        }}*/}
                        {/*        key={index}*/}
                        {/*    />*/}
                        {/*))}*/}
                        <div style={{gap: "10px"}} className="d-flex align-items-center justify-content-start">
                            {leader?.twitter_url && (<Link target="_blank" className="mt-1" href={leader.twitter_url}>
                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M27.5 3L27.5 25C27.5 26.3807 26.3807 27.5 25 27.5L3 27.5C1.61929 27.5 0.5 26.3807 0.5 25L0.5 3C0.5 1.61929 1.61929 0.5 3 0.5L25 0.5C26.3807 0.5 27.5 1.61929 27.5 3Z"
                                        stroke="#1F3AE1"/>
                                    {/* <g clipPath="url(#clip0_282_158)"> */}
                                    <path
                                        d="M20.6331 10.5199C20.6433 10.6688 20.6433 10.8178 20.6433 10.9681C20.6433 15.5476 17.202 20.8291 10.9094 20.8291V20.8264C9.05059 20.8291 7.23037 20.2897 5.66553 19.2727C5.93582 19.3056 6.20746 19.3221 6.47979 19.3228C8.02024 19.3241 9.51666 18.8005 10.7286 17.8363C9.26466 17.8082 7.98095 16.8412 7.5325 15.4295C8.0453 15.5297 8.57369 15.5091 9.07701 15.3698C7.48101 15.0432 6.33279 13.6226 6.33279 11.9728V11.9288C6.80833 12.1972 7.34079 12.3461 7.88543 12.3626C6.38224 11.3448 5.91888 9.31894 6.82662 7.73502C8.56353 9.90022 11.1262 11.2165 13.8772 11.3558C13.6015 10.1521 13.9781 8.89071 14.8669 8.04453C16.2448 6.73238 18.4119 6.79963 19.7071 8.19483C20.4732 8.04179 21.2076 7.75698 21.8796 7.35345C21.6242 8.15571 21.0897 8.83718 20.3757 9.27022C21.0538 9.18924 21.7163 9.00532 22.3402 8.72463C21.8809 9.42189 21.3024 10.0292 20.6331 10.5199Z"
                                        fill="#1F3AE1"/>
                                    {/* </g> */}
                                    <defs>
                                        <clipPath id="clip0_282_158">
                                            <rect width="16.8" height="14" fill="white"
                                                  transform="translate(5.59766 7)"/>
                                        </clipPath>
                                    </defs>
                                </svg>

                            </Link>)}
                            {leader?.linkedin_url && (
                                <Link className="mt-1" target="_blank" href={leader?.linkedin_url}>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5L25 0.5C26.3807 0.5 27.5 1.61929 27.5 3L27.5 25C27.5 26.3807 26.3807 27.5 25 27.5L3 27.5C1.61929 27.5 0.5 26.3807 0.5 25L0.5 3Z"
                                            stroke="#1F3AE1"/>
                                        <path fillRule="evenodd" clipRule="evenodd"
                                              d="M10.349 11.5999H7.17627V21.1325H10.349V11.5999Z" fill="#1F3AE1"/>
                                        <path fillRule="evenodd" clipRule="evenodd"
                                              d="M10.5693 8.64657C10.5487 7.7119 9.8803 7 8.79493 7C7.70957 7 7 7.7119 7 8.64657C7 9.56189 7.6886 10.2943 8.75375 10.2943H8.77403C9.8803 10.2943 10.5693 9.56189 10.5693 8.64657Z"
                                              fill="#1F3AE1"/>
                                        <path fillRule="evenodd" clipRule="evenodd"
                                              d="M21.7962 15.6597C21.7962 12.7316 20.231 11.3689 18.1432 11.3689C16.4587 11.3689 15.7045 12.2941 15.2834 12.9432V11.593H12.1104C12.1522 12.4875 12.1104 21.1257 12.1104 21.1257H15.2834V15.8018C15.2834 15.5169 15.304 15.2327 15.3879 15.0288C15.6172 14.4596 16.1393 13.8703 17.0158 13.8703C18.1644 13.8703 18.6235 14.7444 18.6235 16.0254V21.1254H21.7961L21.7962 15.6597Z"
                                              fill="#1F3AE1"/>
                                    </svg>

                                </Link>)}
                        </div>
                    </div>
                </div>
                <div className={cx(styles.imgWrapperStyles, "d-flex", "align-items-end", "justify-content-end")}>
                    <Image unoptimized width={100} height={100} src={leader.avatar_img}
                           alt={direction === "rtl" ? (leader.first_name_fa + " " + leader.last_name_fa) : (leader.first_name_en + " " + leader.last_name_en)}/>
                </div>
            </div>
            {leader.message_fa && (<div
                className={cx(styles.paragraphContainer, "d-flex", "flex-column")}>
                {direction === "rtl" ? parse(leader.message_fa) : (parse(leader.message_en))}
            </div>)}
        </>
    )
}

export default SingleLeaderHeaderSummery